import React from "react";
import {NavLink} from "react-router-dom";
import "./Common.css";


const Common = (props) => {
    return(
        <>
            <section id="home" className="d-flex align-items-center">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 pt-5 pt-lg-0 d-flex justify-content-center flex-column">
                            <h1>{props.name} <strong className="brand_name"> MDA</strong></h1>
                            <h2 className="mt-3">we are the team of talented developer making website</h2>
                            <NavLink to={props.btnLink}className="btn mt-3 home_btn">{props.btnName}</NavLink>
                        </div>
                        <div className="col-md-6 pt-5 pt-lg-0 text-end">
                            <img src={props.imgsrc} alt="home_image" className="img-fluid animated" />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Common;